import { useLeadForm } from "@/features/leads/contexts/FormLeadContext";
import usePipeline from "@/features/stage/api/usePipeline";
// import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";
import { useSyncronizer } from "@/hooks/useSyncronizer";
import { useAppSelector } from "@/stores/hook";
import { getFromStage } from "@/utils/getFromStage";
import { useState } from "react";
import { useSmartRoute } from "./useSmartRoute";
import useActionResolver from "./useActionResolver";

export default function useActiveIndustryData() {
  const { lead } = useLeadForm();
  const { stageId } = useAppSelector((state) => state.childFunctional);

  // const { industry } = useCurrentIndustry();
  const smartRoute = useSmartRoute();

  const { pipeline } = usePipeline();
  const [currentStage, setCurrentStage] = useState(
    getFromStage({
      pipeline,
      id: stageId,
    })
  );
  const ActionBtn = useActionResolver();

  useSyncronizer(stageId, () => {
    if (pipeline) return;
    setCurrentStage(getFromStage({ pipeline, id: stageId }));
  });

  return { lead, currentStage, smartRoute, ActionBtn };
}
